var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "margin-vertical-s-10 xmoMarketingHubPage__search" },
    [
      _c("OutlookMarketingSearch", {
        attrs: {
          locale: _vm.locale,
          "filter-form": _vm.filterForm,
          icons: _vm.icons,
          "base-path": _vm.basePath,
          "form-name": _vm.formName,
          "show-popular-markets": true,
          "request-path": "outlookHighlightsSearchAjax",
          placeholder: _vm.getPlaceholderString(
            _vm.marketDirectory.children[0].name
          ),
          "is-highlights-header": true,
          "popular-markets": _vm.getPopularMarkets,
        },
        scopedSlots: _vm._u([
          {
            key: "quickstart-header",
            fn: function () {
              return [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-color--dark-blue-gray margin-left-20 marketingHubPage__resultsHeader",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.generateMarketName(_vm.marketDirectory.name)
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "quickstart",
            fn: function () {
              return [
                _c("HighlightMarkets", {
                  attrs: {
                    icons: _vm.icons,
                    "main-market": _vm.generateMarketName(
                      _vm.marketDirectory.name
                    ),
                    "quick-start-items": _vm.getQuickstartItems,
                  },
                }),
                _vm._v(" "),
                [
                  _c(
                    "div",
                    { staticClass: "highlights--footer linkArrowHover" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.trans("XMO_HIGHLIGHTS_UNDERSTAND_MARKETS")
                          ) +
                          "\n                    "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.getPath("outlookHubPage"),
                            role: "menuitem",
                            "data-gtm": "xmoHighlights__mainMarketsLink",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.trans("XMO_HIGHLIGHTS_VISIT_MARKET")) +
                              "\n                        "
                          ),
                          _c(
                            "svg",
                            {
                              staticClass: "stat__svgIcon margin-left-5",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: { href: "#iconArrowRightLongBold" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
              ]
            },
            proxy: true,
          },
          {
            key: "results",
            fn: function (slotProps) {
              return [
                _c("HighlightResults", {
                  attrs: {
                    icons: _vm.icons,
                    "matched-search-results": slotProps.matchedSearchResults,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }